import { useEffect, useRef } from 'react';

export default function RedemptionSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.redeem-animate').forEach((child, i) => {
              (child as HTMLElement).style.animationDelay = `${i * 0.15}s`;
              child.classList.add('animate-fade-in-up');
            });
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative w-full py-24 md:py-32 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/redemption-bar.jpg"
          alt="Bar scene"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-background-950/80" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mx-auto text-center">
          <p className="redeem-animate opacity-0 text-primary-500 text-xs font-bold tracking-[0.3em] uppercase mb-4">
            Real-World Redemption
          </p>
          <h2 className="redeem-animate opacity-0 text-4xl sm:text-5xl md:text-6xl font-black text-foreground-50 tracking-tight leading-tight mb-6">
            YOUR DRINK<br />
            <span className="text-primary-500">IS WAITING.</span>
          </h2>
          <p className="redeem-animate opacity-0 text-foreground-400 text-lg max-w-xl mx-auto leading-relaxed mb-12">
            Show your MARKER QR code at a participating bar. The digital drink becomes a real drink. A night begins.
          </p>

          {/* Flow */}
          <div className="redeem-animate opacity-0 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {[
              { icon: 'ri-smartphone-line', label: 'Digital drink' },
              { icon: 'ri-qr-code-line', label: 'Show QR' },
              { icon: 'ri-goblet-line', label: 'Real drink' },
            ].map((item, i, arr) => (
              <div key={item.label} className="flex items-center gap-6 md:gap-10">
                <div className="flex flex-col items-center gap-3">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-primary-500/20 border border-primary-500/30 flex items-center justify-center">
                    <i className={`${item.icon} text-2xl md:text-3xl text-primary-500`} />
                  </div>
                  <span className="text-foreground-500 text-xs font-medium uppercase tracking-wider">{item.label}</span>
                </div>
                {i < arr.length - 1 && (
                  <i className="ri-arrow-right-line text-primary-500 text-xl hidden md:block" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}